<template>
  <!-- BOTTOM NAVIGATION Store: CD-3 -->
  <nav
    class="fixed bottom-0 left-0 right-0 z-80 bg-white shadow-xl shadow-bottom border-t border-gray-50 h-[65px] px-[20px]"
  >
    <ul class="flex items-center justify-between h-16 px-6">
      <li v-for="item in items" :key="item.name" class="flex-1 flex justify-center">
        <RouterLink
          :to="item.to"
          class="flex flex-col items-center justify-center px-4 rounded-[6px] py-3 text-xs transition"
          :class="isActive(item.to) ? 'bg-gray-50 text-grey-light-800 font-medium h-[65px]' : 'text-gray-500'"
        >
          <span class="max-w-full truncate text-center">{{ item.name }}</span>
          <component :is="item.icon" class="h-6 w-6" />
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import BoostIcon from '@/components/icons/BoostIcon.vue';
import CreditCardIcon from '@/components/icons/CreditCardIcon.vue';
import HomeIcon from '@/components/icons/HomeIcon.vue';
import StoreIcon from '@/components/icons/StoreIcon.vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const items = [
  { name: 'Home', to: '/shopper', icon: HomeIcon },
  { name: 'Boost', to: '/shopper/boost-rewards', icon: BoostIcon },
  { name: 'Lay-By', to: '/shopper/lay-by', icon: CreditCardIcon },
  { name: 'Stores', to: '/shopper/stores', icon: StoreIcon },
];

const isActive = (path: string) => route.path === path;
</script>
